<script lang="ts">
	import type { CTAProps, ImageProps, InlineIconTextProps } from '@app/components/cms/types';
	import { storyblokEditable } from '@storyblok/svelte';
	import { getOptimizedCmsImageUrl, richTextToHTML } from '@app/utils/cms.js';
	import type { ISbRichtext } from '@storyblok/js/dist/types/types';
	import CMSCallToAction from '@app/components/cms/CMSCallToAction.svelte';
	import InlineIconText from '@app/components/cms/InlineIconText.svelte';
	import AdaptiveImage from '$lib/components/AdaptiveImage.svelte';
	import { viewport } from '$lib/stores';
	import { fly } from 'svelte/transition';

	export let blok: {
		title: string;
		baseline: ISbRichtext;
		img: ImageProps;
		ctas: [CTAProps];
		extra: [InlineIconTextProps];
	};
</script>

<div use:storyblokEditable={blok} class="bg-grey-lighter pt-6 pb-8 md:pb-7 lg:h-[670px]">
	<div class="container h-full">
		<div class="lg:flex lg:items-center lg:justify-center lg:gap-5 lg:h-full">
			<div class="space-y-3">
				<h1>{blok.title}</h1>
				<p class="text-xl lg:max-w-[500px]">{@html richTextToHTML(blok.baseline)}</p>
				<div class="space-y-2 md:flex md:space-y-0 md:space-x-3">
					{#each blok.ctas as cta}
						<CMSCallToAction props={cta} />
					{/each}
				</div>
				{#if blok.extra.length}
					<InlineIconText props={blok.extra[0]} />
				{/if}
			</div>

			<div class="w-1/2 flex-shrink-0 flex items-center">
				{#key blok}
					{#if $viewport.isDesktop}
						<div in:fly|global={{ x: 10, delay: 500 }}>
							<AdaptiveImage
								isLazyLoaded={false}
								src={{
									img: getOptimizedCmsImageUrl(blok.img.filename, '0x600'),
									alt: blok.img.alt
								}}
								classNames={'max-h-[600px]'}
							/>
						</div>
					{/if}
				{/key}
			</div>
		</div>
	</div>
</div>
